import { interval, Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';

export function countDownTimer(maxCount: number): Observable<any> {
  const source = interval(1000);
  const obs = source.pipe(
    take(maxCount),
    map(x => --maxCount)
  );

  return obs;
}
